import { render, staticRenderFns } from "./CertificationsListing.vue?vue&type=template&id=2ee48a88&scoped=true&"
import script from "./CertificationsListing.vue?vue&type=script&lang=js&"
export * from "./CertificationsListing.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsListing.vue?vue&type=style&index=0&id=2ee48a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee48a88",
  null
  
)

export default component.exports